import { useQuery } from '@tanstack/react-query';
import { graphql } from '../gql/gql';
import { graphqlRequest, shouldRetryQuery } from '../utils/graphqlClient';
import { FacilityGroupsQuery } from '../gql/graphql';

const facilityGroups = graphql(/* GraphQL */ `
  query facilityGroups {
    facilityGroups {
      facilityGroupId
      name
    }
  }
`);

const useGetFacilityGroups = () => {
  const { data, isLoading } = useQuery<FacilityGroupsQuery>({
    queryKey: ['facilityGroups'],
    queryFn: async () => graphqlRequest<FacilityGroupsQuery>(facilityGroups), // Public endpoint, no auth needed
    staleTime: 3600000,
    retry: shouldRetryQuery,
  });

  return {
    facilityGroups: data,
    facilityGroupsLoading: isLoading,
  };
};

export default useGetFacilityGroups;
